import { DoraCheckbox, DoraButton } from "dora-shared/frontend";
import Radio from "@mui/material/Radio";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useSelector } from "../../redux-store";
import { selectRouting } from "../../ducks/data/routing/selectors";
import UpdateIcon from "@mui/icons-material/Update";
import { setRoutingOptions } from "../../ducks/data/routing";

const LiteVersionRoutingOptions = () => {
  const { t } = useTranslation("dispatching");
  const dispatch = useAppDispatch();
  const routing = useSelector(selectRouting());
  const [isSaving, setIsSaving] = useState(false);
  const [fastest, setFastest] = useState(routing?.fastestRoute || false);
  const [ferry, setFerry] = useState(routing?.allowTravelByFerry || false);

  const save = () => {
    setIsSaving(true);
    dispatch(
      setRoutingOptions({
        routeId: routing!.routeId,
        fastestRoute: fastest,
        allowTravelByFerry: ferry,
      })
    )
      .unwrap()
      .catch(() => {
        // The setRoutingOptions thunk has already reported it and shown the error toast.
      })
      .finally(() => setIsSaving(false));
  };

  if (!routing) {
    return null;
  }

  return (
    <>
      <div className="flex gap-2 items-center">
        <DoraCheckbox
          style={{ marginLeft: 7 }}
          checked={ferry}
          disabled={isSaving}
          onChange={() => setFerry(!ferry)}
        />
        <label>{t("openRouteView.allowTravelByFerry")}</label>
      </div>
      <div className="flex gap-2 items-center mt-1">
        <Radio
          size="small"
          checked={fastest}
          disabled={isSaving}
          onClick={() => setFastest(true)}
        />
        <label>{t("openRouteView.fastestRoute")}</label>
      </div>
      <div className="flex gap-2 items-center mt-1">
        <Radio
          size="small"
          checked={!fastest}
          disabled={isSaving}
          onClick={() => setFastest(false)}
        />
        <label>{t("openRouteView.shortestRoute")}</label>
      </div>
      <DoraButton
        className="flex items-center gap-2 mt-2"
        variant="primary-filled"
        onClick={save}
        disabled={isSaving}
      >
        <UpdateIcon />
        <div>{t("liteVersion.updateRoute")}</div>
      </DoraButton>
    </>
  );
};

export default LiteVersionRoutingOptions;
